import _slicedToArray from "/Users/gerardo/code/appius/webconsulenzeesterni/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import PropTypes from 'prop-types';
import { DEFAULT_BREAKPOINTS, DEFAULT_MIN_BREAKPOINT } from './ThemeProvider';
export function responsivePropType(propType) {
  return PropTypes.oneOfType([propType, PropTypes.shape({
    xs: propType,
    sm: propType,
    md: propType,
    lg: propType,
    xl: propType,
    xxl: propType
  })]);
}
export default function createUtilityClassName(utilityValues) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BREAKPOINTS;
  var minBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MIN_BREAKPOINT;
  var classes = [];
  Object.entries(utilityValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      utilName = _ref2[0],
      utilValue = _ref2[1];
    if (utilValue != null) {
      if (typeof utilValue === 'object') {
        breakpoints.forEach(function (brkPoint) {
          var bpValue = utilValue[brkPoint];
          if (bpValue != null) {
            var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
            classes.push("".concat(utilName).concat(infix, "-").concat(bpValue));
          }
        });
      } else {
        classes.push("".concat(utilName, "-").concat(utilValue));
      }
    }
  });
  return classes;
}